import {
  isDevelopment,
  isLocal,
  isLocalDev,
  isProd,
  isQa,
  isQaFe,
  isStaging,
} from '@m/config/FeatureFlags';
import { KCClient, KCClientValue } from '@m/types/api/iam/Iam';

/** Key used for `resource_access` roles on the JWT (same as Keycloak client id for server roles). */
export function getKeycloakServerClientResourceId(): KCClientValue {
  if (isLocal) {
    return KCClient.LOCAL;
  }
  // qa / qa-fe share Keycloak + APIs with development
  if (isLocalDev || isDevelopment || isQa || isQaFe) {
    return KCClient.DEV;
  }
  if (isStaging) {
    return KCClient.STAGING;
  }
  if (isProd) {
    return KCClient.PRODUCTION;
  }
  throw new Error('Environment not supported');
}
